export const FORM_TEMPLATE_TABS = {
  QUESTION: "question",
  PREVIEW: "preview",
};
